const DB = 'rethread_storage';
const LEGACY_DB = 'friction_journal_storage';
const STORE = 'kv';

function openDb(dbName: string): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(dbName, 1);
    req.onupgradeneeded = () => {
      req.result.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function idbGet(key: string): Promise<Uint8Array | null> {
  const current = await getFromDb(DB, key);
  if (current) return current;
  return getFromDb(LEGACY_DB, key);
}

export async function idbSet(key: string, value: Uint8Array): Promise<void> {
  const db = await openDb(DB);
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).put(value, key);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function idbDelete(key: string): Promise<void> {
  await deleteFromDb(DB, key);
  await deleteFromDb(LEGACY_DB, key);
}

async function getFromDb(dbName: string, key: string): Promise<Uint8Array | null> {
  const db = await openDb(dbName);
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const req = tx.objectStore(STORE).get(key);
    req.onsuccess = () => {
      const value = req.result as Uint8Array | ArrayBuffer | null | undefined;
      if (!value) {
        resolve(null);
        return;
      }
      if (value instanceof Uint8Array) {
        resolve(value);
        return;
      }
      if (value instanceof ArrayBuffer) {
        resolve(new Uint8Array(value));
        return;
      }
      resolve(null);
    };
    req.onerror = () => reject(req.error);
  });
}

async function deleteFromDb(dbName: string, key: string): Promise<void> {
  const db = await openDb(dbName);
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).delete(key);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}
